import { render } from "./WalletButton.vue?vue&type=template&id=085fcc7d&scoped=true&ts=true"
import script from "./WalletButton.vue?vue&type=script&lang=ts"
export * from "./WalletButton.vue?vue&type=script&lang=ts"

import "./WalletButton.vue?vue&type=style&index=0&id=085fcc7d&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-085fcc7d"]])

export default __exports__